<template>
  <div>
    <div v-if="files.length <= 0 || allowReupload" class="main mb-3">
      <div
        :class="
          inputError || errorText
            ? 'dropzone-container-error'
            : 'dropzone-container'
        "
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        @click="openFilePicker"
      >
        <input
          type="file"
          multiple
          :name="inputName"
          :id="inputId"
          class="hidden-input"
          @change="onChange"
          :ref="inputId"
          :accept="acceptedFiles ? acceptedFiles : ''"
        />

        <label for="fileInput" class="file-label" style="min-height: 10rem">
          <div
            class="d-flex flex-column justify-content-center align-items-center"
            style="font-size: 16px; min-height: 10rem"
          >
            <img
              class="mb-3"
              style="width: 26px"
              src="~@/assets/icon/upload.svg"
            />
            <div v-if="isDragging">Release to drop files here.</div>
            <div v-else>{{ placeholder }}</div>
          </div>
        </label>
      </div>
    </div>
    <div v-if="errorText" class="text-danger">
      {{ errorText }}
    </div>
    <div v-if="inputError" class="text-danger">
      {{ inputError }}
    </div>
    <div
      v-if="files.length <= 0 || allowReupload"
      class="mt-3"
      style="color: #9d9d9d"
    >
      {{ note }}
    </div>
    <hr v-if="allowReupload && files.length > 0" />
    <div v-if="files.length > 0">
      <div v-for="file in files" :key="file.name" class="d-flex flex-column">
        <div class="file-list-card mb-3">
          <img src="~@/assets/icon/file.svg" />
          <p class="m-0">{{ file.name }}</p>
          <button
            class="btn btn-sm btn-action btn-action-trash"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Delete"
            @click="remove(files.indexOf(file))"
          >
            <img src="~@/assets/icon/trash.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DragAndDropFile",
  props: {
    acceptedFiles: String,
    note: String,
    errorText: String,
    shouldClearState: Boolean,
    placeholder: {
      type: String,
      required: false,
      default: "Click or drag file(s) to this area to upload",
    },
    allowReupload: {
      type: Boolean,
      required: false,
    },
    inputName: {
      type: String,
      required: false,
      default: "file",
    },
    inputId: {
      type: String,
      required: false,
      default: "file",
    },
    maxFiles: {
      type: Number,
      required: false,
    },
    maxSizedFiles: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      isDragging: false,
      files: [],
      inputError: "",
    };
  },
  methods: {
    // onChange() {
    //   this.files.push(...this.$refs.file.files);
    // },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      // this.$refs.file.files = e.dataTransfer.files;
      // this.onChange();
      this.files = [...this.files, ...e.dataTransfer.files];
      this.isDragging = false;
    },
    openFilePicker() {
      this.$refs[this.inputId].click();
    },
    remove(i) {
      this.files.splice(i, 1);
      this.$emit("change-file", this.files);
    },
    onChange(e) {
      this.inputError = "";
      let incomingFiles = Array.from(e.target.files);
      // Reset Input state
      this.$refs[this.inputId].value = null;
      this.$refs[this.inputId].files = null;

      // Rest of the logic
      if (this.maxFiles && incomingFiles.length > this.maxFiles) {
        this.inputError = "Jumlah dokumen melebihi batas";
        return null;
      }
      for (const incomingFile of incomingFiles) {
        if (this.maxSizedFiles && incomingFile.size > this.maxSizedFiles) {
          this.inputError = "Ukuran file melebihi batas";
          return null;
        }
      }
      const fileExist = this.files.some((r) =>
        incomingFiles.some(
          (file) => file.name === r.name && file.size === r.size
        )
      );
      if (fileExist) {
        alert("New upload contains files that already exist");
      } else {
        this.files = [...this.files, ...incomingFiles];
      }
      this.$emit("change-file", this.files);
    },
  },
  watch: {
    shouldClearState(newVal, oldVal) {
      if (oldVal !== newVal && newVal === true) {
        this.files = [];
        // this.$emit("on-finish-clear-state");
      }
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
}

.dropzone-container {
  min-height: 10rem;
  /* background: #f7fafc;s */
  border: 1px dashed #cccfd3;
  width: 100%;
  border-radius: 10px;
}

.dropzone-container-error {
  min-height: 10rem;
  /* background: #f7fafc;s */
  border: 1px dashed #dc3545;
  width: 100%;
  border-radius: 10px;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}

.file-list-card {
  display: flex;
  padding: 1rem;
  gap: 12px;
  align-items: center;
  border: 1px solid rgba(46, 54, 70, 0.2);
  border-radius: 8px;
}

.btn-action-trash {
  border-color: rgba(255, 52, 68, 0.5);
}

.btn-action {
  border-radius: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Insurance/CustomComponent/DragAndDropFile.vue